import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { organization } from "../../config";
import axios from "axios";

export default function FundraiserLevelPublic() {
    const { fid, pid } = useParams();

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [coverFee, setCoverFee] = useState(false);

    useEffect(() => {
        axios
            .get(`/api/fundraisers/${fid}/public`)
            .then((res) => setData(res.data))
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, [fid]);

    if (loading) return <p className="text-center mt-5">Loading…</p>;
    if (!data) return <p className="text-center mt-5">Fundraiser not found.</p>;
    if (data.archived) return (
        <div className="container my-5 text-center">
            <h4>This fundraiser is no longer active.</h4>
            <p>
                <Link to="/" className="small-link" style={{ color: "#2E5D3A" }}>
                    &larr; Back to {organization.shortName} website
                </Link>
            </p>
        </div>
    );

    const priceData = data.price_items.find((i) => i.price_id === pid);
    if (!priceData)
        return <p className="text-center mt-5">Donation level not found.</p>;

    const baseAmount = priceData.amount_cents / 100;
    const feeAmount = priceData.fee_cents / 100;

    const donateUrl = coverFee ? priceData.with_fee_url : priceData.payment_link_url;

    return (
        <div className="container my-5" style={{ maxWidth: "700px" }}>
            <div className="text-center mb-2">
                <Link to="/" className="small-link" style={{ color: "#2E5D3A" }}>
                    &larr; {organization.shortName} Website
                </Link>
            </div>

            <h2 className="mb-3 text-center">{data.title}</h2>
            {data.description && (
                <p className="lead text-center">{data.description}</p>
            )}

            <div
                className="border rounded p-4 d-flex flex-column align-items-center mx-auto"
                style={{ maxWidth: "350px" }}
            >
                <h3 className="mb-2">{priceData.label}</h3>
                <strong className="mb-3">
                    ${baseAmount.toFixed(2)}
                    {coverFee && (
                        <>
                            {" "}
                            + <span className="text-muted">${feeAmount.toFixed(2)} fee</span>
                        </>
                    )}
                </strong>

                <p>Stripe, our payment processor, charges us a fee of $0.30 plus 2.9% per transaction. Would you like to cover this fee?</p>

                <div className="form-check mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="coverFee"
                        checked={coverFee}
                        onChange={() => setCoverFee(!coverFee)}
                    />
                    <label className="form-check-label text-body-secondary" htmlFor="coverFee">
                        I'd like to cover the processing fee
                        {feeAmount > 0 && ` (+$${feeAmount.toFixed(2)})`}
                    </label>
                </div>

                <a
                    href={donateUrl}
                    rel="noopener noreferrer"
                    className="btn btn-admin w-100"
                >
                    Donate&nbsp;${(coverFee ? baseAmount + feeAmount : baseAmount).toFixed(2)}
                </a>
            </div>
            <div className="container text-center mt-3">
                <Link className="link-small text-decoration-none" style={{ color: "#2E5D3A" }} to={`/fundraisers/${fid}`}>
                    &larr; Back
                </Link>
            </div>
        </div>
    );
}
